$(document).ready(function(){
  $('.mobile-nav .drawer_close').on('click', function(){
  	$('.site-header').trigger('click');
  });
  $('.find-code').on('click', function(){
  	$('.modal-container').addClass('show');
  });
  $('.modal-close').on('click', function(){
  	$('.modal-container').removeClass('show');
  });
  $('.product-single__media-group').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.product-single__thumbnails'
  });
  $('.product-single__thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      asNavFor: '.product-single__media-group',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
            breakpoint: 992,
            settings: {
              vertical: false,
            }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            slidesToShow: 2,
          }
        }
      ]
  });
  $('.oi-question').click(function(){
    $(this).parent().siblings().removeClass('oi-active-faq');
    $(this).parent().addClass('oi-active-faq');
  });
});
